import { useState } from "react";
import { ElectricitySupplierOffer } from "@/types";
import { triggerHandler } from "@ygtechnologies/rubus-frontend-utilities";
import theme from './ElectricitySupplier.module.scss';
import { Thumbnail } from "@ygtechnologies/bygr-frontend-component-library";
import ReorderableList from "@/components/ReordarableList/ReorderableList";
import { getOfferLogo, updateElectricitySupplierOffers } from "@/services/serviceProvider";
import { Button, ButtonBar, Dialog } from '@ygtechnologies/rubus-ui';

interface ElectricitySupplierReorderDialogProps {
    offers: ElectricitySupplierOffer[];
    show: boolean;
    onClose(): void;
    onAccept(): void;
}

const ElectricitySupplierReorderDialog: React.FC<ElectricitySupplierReorderDialogProps> = ({
    offers,
    show,
    onClose,
    onAccept
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [sortedOffers, setSortedOffers] = useState<ElectricitySupplierOffer[]>([]);

    const handleOpen = () => {
        setSortedOffers(offers.sort((a,b) => a.sortOrder - b.sortOrder));
    };

    const handleClose = () => {
        triggerHandler(onClose);
    };
    
    const handleSubmit = async () => {
        setIsSaving(true);

        try {
            await updateElectricitySupplierOffers(orderItems(sortedOffers));

            triggerHandler(onAccept);
            triggerHandler(onClose);
        } finally {
            setIsSaving(false);
        }
    }

    const orderItems = (itemsToOrder: ElectricitySupplierOffer[]) => {
        for (let i = 0; i < itemsToOrder.length; i++) {
            itemsToOrder[i].sortOrder = i + 1;
        }

        return itemsToOrder;
    }

    const renderItem = (offer: ElectricitySupplierOffer) => {
        return (
            <div className={theme.item}>
                <div className={theme.thumbnail}>
                    <Thumbnail draggable={false} src={getOfferLogo(offer.logoId)} />
                </div>

                <div className={theme.offerName}>
                    <strong>{offer.highlightedTitle1}</strong>
                </div>

                <div className={theme.supplier}>
                    <strong>{offer.supplier}</strong>
                </div>
            </div>
        );
    }

    return(
        <Dialog open={show} onOpenChange={(open) => !open && handleClose()} onOpen={handleOpen}>
            <Dialog.Content contentWidth="lg">
                <Dialog.Header>Reorder offers</Dialog.Header>
                {sortedOffers && <ReorderableList data={sortedOffers} idField="id" onChange={setSortedOffers} renderer={renderItem} />}
                <ButtonBar>
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={handleClose} disabled={isSaving}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary" loading={isSaving} onClick={handleSubmit}>
                            Save
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </Dialog.Content>
        </Dialog>
    );
}

export default ElectricitySupplierReorderDialog;